import React from 'react';
import KendoView from '../../components/crud/kendo';
import { authenticationService } from '../../components/authorization';

const config = [
    { field: 'invoiceNumber', title: 'Invoice Number', isGrid: true },
    { field: 'countRate', title: 'Count Rate', type: 'number', isGrid: true },
    { field: 'functionCode', title: 'Function Code', isGrid: true },
    { field: 'revenueCode', title: 'Revenue Code', isGrid: true },
    { field: 'activityCode', title: 'Activity Code', isGrid: true },
    { field: 'faaCode', title: 'FAA Code', isGrid: true },
    { field: 'faaDescription', title: 'FAA Description', isGrid: true },
    { field: 'module', title: 'Module', isGrid: true },
    { field: 'entityId', title: 'Entity Id', isGrid: true },
    { field: 'charge', title: 'Charge', type: 'number', isGrid: true },
    { field: 'isPaid', title: 'Is Paid', template: "#= (isPaid == 1 || isPaid === true || ispaid == 1 || ispaid === true) ? 'Yes' : 'No' #", isGrid: true },


    { field: 'name', title: 'Name', isGrid: true },
    { field: 'companyName', title: 'Company Name', isGrid: true },
    { field: 'vendorCode', title: 'Vendor Code', isGrid: true },
    { field: 'BillingProfile', title: 'Billing Profile', isGrid: true },
    { field: 'amountDue', title: 'Amount Due', type: 'number', isGrid: true },
    { field: 'amountPaid', title: 'Amount Paid', type: 'number', isGrid: true },
    { field: 'dOTNumber', title: 'DOT Number', isGrid: true },
    { field: 'invoiceCycle', title: 'Invoice Cycle', isGrid: true },

    { field: 'invoiceDate', title: 'Invoice Date', type: 'date', isGrid: true },
    { field: 'billedDate', title: 'Billed Date', type: 'date', isGrid: true },
    { field: 'status', title: 'Status', isGrid: true },
    { field: 'fiscalYear', title: 'Fiscal Year', isGrid: true },
    { field: 'paidYear', title: 'Paid Year', isGrid: true },
    { field: 'paidFiscalYear', title: 'Paid Fiscal Year', isGrid: true },
    { field: 'paidDate', title: 'Paid Date', type: 'date', isGrid: true },
    { field: 'paidMonth', title: 'Paid Month', isGrid: true },
    { field: 'cameraEvent', title: 'Camera Event', template: "#= cameraEvent == 1 ? 'Yes' : 'No' #", isGrid: true },
    { field: 'invoiceMonth', title: 'Invoice Month', isGrid: true },
    { field: 'day30', title: 'Day 30', type: 'number', isGrid: true },
    { field: 'day60', title: 'Day 60', type: 'number', isGrid: true },
    { field: 'day90', title: 'Day 90', type: 'number', isGrid: true },
    { field: 'day120', title: 'Day 120', type: 'number', isGrid: true },
    { field: 'over120', title: 'Over 120', type: 'number', isGrid: true },
]



export default function allactivity() {
    const tokenParam = `?token=${encodeURIComponent(authenticationService.getRefreshToken())}`
    return <KendoView grid='ALLACTIVITY_REPORT_V2' param='id' sort='invoicedate' link='#' url={process.env.REACT_APP_KENDO_API + '/api/Reports/AllActivity' + tokenParam} columns={config} title='AllActivity' />
}